export default function genererCriteresRechercheCompteClient() {
  return {
    auto: '',
    numero: '',
    libelle: '',
    types: [],
    periode: {
      dateDebut: null,
      dateFin: null,
    },
    debit: {
      borneBasse: 0,
      borneHaute: 999999999,
    },
    credit: {
      borneBasse: 0,
      borneHaute: 999999999,
    },
    tiersId: null,
    societeId: null,
    etats: [],
  };
}
